import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { Container, Navbar, Offcanvas } from 'react-bootstrap';
import NavigationItem from './NavigationItem';
import Logo from '../../logo';
// import ThemeToggler from '../../theme/ThemeToggler';

interface MainNavigationProps {
  isMega: boolean;
  isOpen: boolean;
  onToggle: () => void;
}

const MainNavigation: React.FC<MainNavigationProps> = ({ isMega, isOpen, onToggle }) => {
  const location = useRouter();

  // Navigation state for submenus
  const [openAbout, setOpenAbout] = useState(false);
  const [openVideos, setOpenVideos] = useState(false);

  // Helper to check if path is active
  const isActive = (paths: string | string[]): boolean => {
    if (typeof paths === 'string') {
      return location.asPath === paths;
    }
    return paths.some(path => {
      if (path.endsWith('*')) {
        const basePath = path.slice(0, -1);
        return location.asPath.startsWith(basePath);
      }
      return location.asPath === path;
    });
  };

  // Main nav active states
  const isAboutActive = isActive(['/about/welcome', '/about/ms-alice', '/about/contact', '/about/faq']);
  const isVideosActive = isActive([
    '/videos',
    '/videos/featured',
    '/videos/new-releases',
    '/videos/cyclical',
    '/videos/alices-picks',
    '/videos/series',
    '/videos/instructor-inspo',
    '/videos/style'
  ]);
  const isEventsActive = isActive('/events');

  // TODO: Replace with real auth state
  const isLoggedIn = false; // Placeholder for auth state

  return (
    <Navbar
      expand="xl"
      className={`offcanvas mobile-offcanvas nav hover-nav horizontal-nav py-xl-0 ${
        isOpen ? "show" : ""
      } ${isMega ? "mega-menu-content" : ""}`}
      style={{
        visibility: `${isOpen ? "visible" : "hidden"}`,
      }}
      id="navbar_main"
    >
      <Container fluid className="container-fluid p-lg-0">
        <Offcanvas.Header className="px-0" closeButton>
          <div className="navbar-brand ms-3">
            <Logo />
          </div>
        </Offcanvas.Header>
        <ul className="navbar-nav iq-nav-menu list-unstyled" id="header-menu">
          {/* GSchool logo links to home - already handled by Logo component */}

          {/* About Navigation */}
          <NavigationItem
            title="About"
            isActive={isAboutActive}
            hasSubMenu
            onClick={() => setOpenAbout(!openAbout)}
          >
            <NavigationItem
              title="Welcome"
              path="/about/welcome"
              isActive={isActive('/about/welcome')}
            />
            <NavigationItem
              title="Ms Alice"
              path="/about/ms-alice"
              isActive={isActive('/about/ms-alice')}
            />
            <NavigationItem
              title="Contact"
              path="/about/contact"
              isActive={isActive('/about/contact')}
            />
            <NavigationItem
              title="FAQ"
              path="/about/faq"
              isActive={isActive('/about/faq')}
            />
          </NavigationItem>

          {/* Videos Navigation */}
          <NavigationItem
            title="Videos"
            isActive={isVideosActive}
            hasSubMenu
            onClick={() => setOpenVideos(!openVideos)}
          >
            <NavigationItem
              title="All Videos"
              path="/videos"
              isActive={isActive('/videos')}
            />
            <NavigationItem
              title="Featured"
              path="/videos/featured"
              isActive={isActive('/videos/featured')}
            />
            <NavigationItem
              title="New Releases"
              path="/videos/new-releases"
              isActive={isActive('/videos/new-releases')}
            />
            <NavigationItem
              title="Cyclical"
              path="/videos/cyclical"
              isActive={isActive('/videos/cyclical')}
            />
            <NavigationItem
              title="Alice's Picks"
              path="/videos/alices-picks"
              isActive={isActive('/videos/alices-picks')}
            />
            <NavigationItem
              title="Series"
              path="/videos/series"
              isActive={isActive('/videos/series')}
            />
            <NavigationItem
              title="Instructor Inspo"
              path="/videos/instructor-inspo"
              isActive={isActive('/videos/instructor-inspo')}
            />
            <NavigationItem
              title="Style"
              path="/videos/style"
              isActive={isActive('/videos/style')}
            />
          </NavigationItem>

          {/* Live Events */}
          <NavigationItem
            title="Live Events"
            path="/events"
            isActive={isEventsActive}
          />
        </ul>

      </Container>
    </Navbar>
  );
};

export default MainNavigation;
